const STASH_ENV_PLACEHOLDER = '__STASH_ENV__';

/**
 * Resolve the Datadog RUM `env` tag.
 *
 * Deployed pages load `/sign-up/runtime-env.js`, which sets `window.Stash.env`
 * from the pod before the app starts (`prod` is written as `production`).
 * When that script does not run (local Vite) or the value is empty,
 * `window.Stash.env` stays the literal `__STASH_ENV__` placeholder, which
 * Datadog lowercases to `__stash_env__` and reports as a bogus RUM environment.
 * Normalize those cases to `local` so env filtering in RUM stays meaningful.
 */
export const resolveRumEnv = (stashEnv: string | null | undefined): string => {
	if (!stashEnv || stashEnv === STASH_ENV_PLACEHOLDER) {
		return 'local';
	}
	return stashEnv;
};
